module.exports = __webpack_public_path__ + "img/branding-logo-belettering-carwrap-huisstijl-full-on-eventsector-4.eb349847.jpg";